import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';
import chipset_features from '../../../assets/v2/Partner/chipset.svg';
import ODMs from '../../../assets/v2/Partner/odms.svg';
import oems from '../../../assets/v2/Partner/oems.svg';
import appvendor from '../../../assets/v2/Partner/appvendor.svg';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import { navigate } from '@reach/router';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  // background-color: #f9fbfe;
  padding: 96px 0 !important;
`;

const BlueButtonWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 96px;
}
@media (max-width: 768px) {
  height: 78px;
}
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 2rem;
  margin-bottom: 1rem;
  grid-gap: 6rem 10rem;
  width: 90%;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

const TitlesContainer = styled.div`
  // padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  height: 48px;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.9;
  letter-spacing: normal;
  color: #4f5263;
  text-align: center;

  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    // margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;

const SectionTitle = styled(H1)`
  padding: 2rem 0 0;
  @media (max-width: 520px) {
    text-align: center;
    width: 80%;
    padding: 0 0 1rem;
    padding-bottom: 0;
  }

  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2b2e3c;
`;
const ExploreDocs = styled.div`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
const ExploreText = styled.div`
  color: #4d3b95;
  text-align: center;
  display: flex;
  text-transform: none;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1440px) {
    font-size: 16px;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

export default () => (
  <>
    <Section>
      <SectionTitle>Esper’s Android Partner Categories</SectionTitle>
      <GridContainer style={{ maxWidth: '1024px' }}>
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImg src={chipset_features} />
                </ImgWrapper>
              </TitlesContainer>
              <GridItemContent>
                <GridTitle>Chipset Vendors </GridTitle>
              </GridItemContent>
            </TextWrapper>
          </InnerContainer>
        </GridItem>
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImg src={ODMs} />
                </ImgWrapper>
              </TitlesContainer>
              <GridItemContent>
                <GridTitle>ODMs and CMs </GridTitle>
              </GridItemContent>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImg src={oems} />
                </ImgWrapper>
              </TitlesContainer>
              <GridItemContent>
                <GridTitle>OEMs </GridTitle>
              </GridItemContent>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImg src={appvendor} />
                </ImgWrapper>
              </TitlesContainer>
              <GridItemContent>
                <GridTitle>Application Vendors </GridTitle>
              </GridItemContent>
            </TextWrapper>
          </InnerContainer>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
